<ng-container *ngIf="isSelecting; else display">
  <div class="flex-row field-input">
    <mat-form-field appearance="outline">
      <input
        matInput
        [(ngModel)]="searchTerm"
        [matAutocomplete]="auto"
        (ngModelChange)="onSearchTermChanged()"
        placeholder="Kies een bord"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="signSelected($event.option.value)"
      >
        <mat-option *ngFor="let item of selectableSigns" [value]="item">
          {{ item.title }} {{ item.signMeasurementsDisplay }}
          {{ item.pressType?.label }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
</ng-container>
<ng-template #display>
  <div class="flex-row display-container">
    <label
      >{{ sign.pairedSign.title }}
      {{ sign.pairedSign.signMeasurementsDisplay }}
      {{ sign.pairedSign.pressType?.label }}</label
    >
    <mat-icon
      [matTooltip]="'Aanpassen'"
      class="clickable"
      (click)="startEditing()"
      >edit</mat-icon
    >
  </div>
</ng-template>
